Monitoring.Views ||= {}

class Monitoring.Views.ReplyBlacklistGroupsView extends Backbone.View

  template:             JST['backbone/templates/account_settings/reply_blacklists/groupsview/groups_container']
  appliedGroupsTemplate:  JST['backbone/templates/account_settings/reply_blacklists/groupsview/applied']
  possibleGroupsTemplate: JST['backbone/templates/account_settings/reply_blacklists/groupsview/possible']
  controlsTemplate:     JST['backbone/templates/account_settings/reply_blacklists/groupsview/controls']

  className: 'bottom'

  events:
    'change select.groups': 'onAdd'
    'click button.group': 'onClickGroupButton'
    'click .done': 'onSave'
    'click .clean': 'onClean'

  initialize: (@options = {}) ->
    @possibleGroups = @options.possibleGroups
    @initiallySelectedGroupCodes = @options.selectedGroupCodes || []
    @currentlySelectedGroupCodes = @options.selectedGroupCodes || []
    @suggestedGroups = @options.suggestedGroups
    @deselectedGroups = []
    @labelNoneGroup     = @options.labelNoneGroup
    @labelAtLeastOneGroup = @options.labelAtLeastOneGroup
    @evaluateItems()

  render: =>
    @$el.html(@template(@))
    @appliedGroupsContainer().html(@appliedGroupsTemplate(@))
    @controlsContainer().html(@controlsTemplate(@))
    @initializeChosen()
    @$el

  # public

  # private

  appliedGroupsContainer: ->
    @$el.find('.groups-editor-applied')

  possibleGroupsContainer: ->
    @$el.find('.groups-editor-possible')

  controlsContainer: ->
    @$el.find('.groups-editor-controls')

  initializeChosen: ->
    @possibleGroupsContainer().html(@possibleGroupsTemplate(@))
    select = @$el.find('select.groups')
    select.chosen(width: 'auto', search_contains: true)
    chosenDrop = @$el.find('.chosen-drop').hide()
    select.on('chosen:showing_dropdown', ->
      chosenDrop.show()
    )
    select.on('chosen:hiding_dropdown', ->
      chosenDrop.hide()
    )

  onClickGroupButton: (evt) =>
    target = $(evt.currentTarget)
    clientCode = target.data('code')
    group = _.find(@possibleGroups, (t) -> t.code == clientCode)
    @currentlySelectedGroupCodes = _.without(@currentlySelectedGroupCodes, clientCode)
    @deselectedGroups = @deselectedGroups.concat(group)
    @evaluateItems()
    @trigger('changed:groups', @currentlySelectedGroupCodes)

  hasChanges: ->
    !_.isEqual(_.sortBy(@currentlySelectedGroupCodes), _.sortBy(@initiallySelectedGroupCodes))

  onAdd: (evt) =>
    target = $(evt.currentTarget)
    clientCode = target.val()
    @currentlySelectedGroupCodes = _.uniq((@currentlySelectedGroupCodes || []).concat(clientCode))
    @evaluateItems()
    target.find('option:selected').remove()
    target.trigger('chosen:updated')
    @trigger('changed:groups', @currentlySelectedGroupCodes)

  onClean: =>
    @currentlySelectedGroupCodes = []
    @deselectedGroups = []
    @evaluateItems()
    @render()
    false

  evaluateItems: =>
    if @labelNoneGroup in @currentlySelectedGroupCodes
      @currentlySelectedGroupCodes = [@labelNoneGroup]
      @possibleGroups = []
    else if @labelAtLeastOneGroup in @currentlySelectedGroupCodes
      @currentlySelectedGroupCodes = [@labelAtLeastOneGroup]
      @possibleGroups = []
    else
      @possibleGroups = @options.possibleGroups
    @render()

  currentlySelectedGroups: ->
    ret = _.map @currentlySelectedGroupCodes, (groupCode) =>
      _.find @possibleGroups, (group) => group.code == groupCode
    _.compact ret

  currentlySelectedAndVisibleGroupCodes: ->
    _.filter @currentlySelectedGroups(), (group) => !group.hidden


  isMainGroup: (group) ->
    @hasGroup(group) or @isHotGroup(group) or @isSuggestedGroup(group)

  hasGroup: (group) ->
    @arrayHasGroup(@currentlySelectedGroupCodes, group)

  isHotGroup: (group) ->
    group.hot_group

  isSuggestedGroup: (group) ->
    @arrayHasGroup(@suggestedGroups, group)

  arrayHasGroup: (array, group) ->
    group = group || {}
    description = group.description || ''
    code = group.code || ''
    _.intersection(array, [group, group.description, group.code]).length > 0

  negativeGroups: ->
    _.filter(@possibleGroups, (group) => group.implies_rejection == true && !@isMainGroup(group))

  neutralGroups: ->
    _.filter(@possibleGroups, (group) => !group.implies_rejection && !@isMainGroup(group))

  unappliedGroups: ->
    @neutralGroups().concat(@negativeGroups()) # does not include suggested groups
